/**
 * Wave 7c: Color utility shared between VoiceBotPanel and CalendlyPanel.
 * Multiplies each RGB channel by `factor` and clamps to 0-255 implicitly
 * via Math.round (callers should pass 0..1 to darken or 1..2 to lighten).
 */
export const adjustBrightness = (color: string, factor: number): string => {
  const hex = color.replace('#', '')
  const r = Math.round(Number.parseInt(hex.substring(0, 2), 16) * factor)
  const g = Math.round(Number.parseInt(hex.substring(2, 4), 16) * factor)
  const b = Math.round(Number.parseInt(hex.substring(4, 6), 16) * factor)
  const toHex = (n: number) => n.toString(16).padStart(2, '0')
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`
}
